import { Button, Stack } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { LoadingButton } from 'components/common/LoadingButton'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useStatusCheckDetailsContext } from 'context/status-checks/StatusCheckDetailsContext'

export const CreateStatusCheckFormActions: React.FC<{ onCancel(): void }> = ({
  onCancel
}) => {
  const { isStatusCheckConnectionValidated, isStatusCheckEvaluationValidated } =
    useStatusCheckDetailsContext()

  const { formState } = useFormContext<StatusCheckFormValues>()
  const { isDirty, isValid, isSubmitting } = formState
  const canSubmit =
    isDirty &&
    isValid &&
    isStatusCheckConnectionValidated &&
    isStatusCheckEvaluationValidated &&
    !isSubmitting

  return (
    <Stack direction="row" sx={{ columnGap: 2 }}>
      <Button disabled={isSubmitting} variant="contained" onClick={onCancel}>
        Back
      </Button>
      <LoadingButton
        data-testid="create-status-check-save-button"
        isDisabled={!canSubmit}
        isLoading={isSubmitting}
        type="submit"
        variant="contained"
      >
        {isSubmitting ? 'Creating Health Check...' : 'Create Health Check'}
      </LoadingButton>
    </Stack>
  )
}
